import HomeMain from "@components/HomeMain";
import { Mask } from "antd-mobile";
import { FC } from "react";
import { getWeatherDomainType, isLocalLink, isTestLink } from "@/utils";
import { useTranslation } from "react-i18next";
import { getPrivacyPolicyUrl } from "@/utils/copyright";
const HomeMask: FC = () => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const userAction = LocalStorage.getItem("userAction");
    if (userAction === "accept") {
      setVisible(false);
    } else {
      setVisible(true);
    }
  }, []);
  function handleClick(action: string) {
    return () => {
      if (action === "accept") {
        LocalStorage.setItem("userAction", "accept");
      }
      setVisible(false);
    };
  }
  const { t: $t } = useTranslation();

  return (
    <>
      <Mask getContainer={document.body} visible={visible}>
        <div className="absolute bottom-12 left-50% translate-x-[-50%] w-310 h-182 bg-[white] rounded-21 flex flex-col items-center gap-y-20">
          <div className="text-ellipsis-5 break-normal p-[20px_14px_0] font-400 text-14 color-[#444444] lh-19">
            {getWeatherDomainType() === "24hweather.com" ? $t("title51") : $t("title45")}
            <a className="underline color-[#3482FF]" href={getPrivacyPolicyUrl()}>
              {$t("title46")}
            </a>
            {$t("title47")}
          </div>
          <div
            className="bg-[#3482FF] w-123 h-34 lh-34 center rounded-20 text-center font-500 text-14 color-[#fff]"
            onClick={handleClick("accept")}
          >
            {$t("title44")}
          </div>
        </div>
      </Mask>
    </>
  );
};
const Home: React.FC = () => {
  const { prefix } = usePrefix();
  return (
    <Container>
      <HomeMain />
      {getWeatherDomainType() != "24hweather.com" &&
        ![...domainMap.mils, ...domainMap["v-ls"]].includes(window.location.hostname) &&
        !isTestLink(domains) &&
        !isLocalLink() && <HomeMask />}
      {getWeatherDomainType() != "24hweather.com" &&
        ![...domainMap.mils, ...domainMap["v-ls"]].includes(`${prefix}.comfortweather.com`) &&
        !domains.includes(window.location.hostname) && <HomeMask />}
    </Container>
  );
};
export default Home;
